// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4e49850","735":"1a273beb"}[chunkId] + ".chunk.js";
};